import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "v-application--wrap" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  class: "fondo-public-tracking",
  style: {"z-index":"-1","position":"absolute","height":"100vh","width":"100vw"}
}, null, -1)
const _hoisted_3 = { class: "container tracking-landing" }
const _hoisted_4 = { class: "w-lg-700px bg-white rounded shadow-sm m-8 p-10 p-lg-15 mx-auto" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  class: "card",
  color: "#f9f9f9"
}
const _hoisted_7 = { class: "card-title" }
const _hoisted_8 = {
  class: "row",
  align: "center"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", {
  class: "col titulo1",
  align: "center"
}, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder" }, "Seguimiento de envío")
], -1)
const _hoisted_10 = {
  class: "col",
  align: "right"
}
const _hoisted_11 = { class: "fw-bolder store_logo" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "d-flex align-center" }
const _hoisted_16 = { class: "text-h4 mr-2 black--text" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" N° ")
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = /*#__PURE__*/_createVNode("p", { class: "text-h6 black--text text-right" }, " Última actualización: ", -1)
const _hoisted_22 = { class: "text-h6  text-right" }
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "text-h5 black--text" }, "Datos de envío", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("p", { class: "text-h6" }, "Distribuido por: ")
], -1)
const _hoisted_27 = { class: "text-h6 black--text ml-2 carrier_link" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "fas fa-external-link-alt" }, null, -1)
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("p", { class: "text-h6" }, "N° de orden:")
], -1)
const _hoisted_33 = { class: "text-h6 black--text ml-2" }
const _hoisted_34 = {
  class: "card-body",
  style: {"position":"relative"}
}
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/_createVNode("hr", {
  class: "d-xs-none align-self-center",
  style: {"width":"100%","position":"absolute"}
}, null, -1)
const _hoisted_37 = {
  style: {"z-index":"2"},
  class: "align-center col-sm-3 text-center"
}
const _hoisted_38 = {
  key: 0,
  class: "text-h6 black--text "
}
const _hoisted_39 = {
  style: {"z-index":"2"},
  class: "align-center col-sm-3 text-center"
}
const _hoisted_40 = {
  key: 0,
  class: "text-h6 black--text "
}
const _hoisted_41 = {
  style: {"z-index":"2"},
  class: "align-center col-sm-3 text-center"
}
const _hoisted_42 = {
  key: 0,
  class: "text-h6 black--text "
}
const _hoisted_43 = {
  style: {"z-index":"2"},
  class: "align-center col-sm-3 text-center"
}
const _hoisted_44 = {
  key: 0,
  class: "text-h6 black--text font-weight-bold"
}
const _hoisted_45 = { class: "card-body" }
const _hoisted_46 = /*#__PURE__*/_createVNode("p", { class: "text-h5  black--text" }, "Historial de estados", -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_48 = { class: "text-h6" }
const _hoisted_49 = { class: "svg-icon svg-icon-3 mb-3" }
const _hoisted_50 = /*#__PURE__*/_createVNode("i", { class: "mdi mdi-calendar-month mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_icono_en_preparacion = _resolveComponent("icono-en-preparacion")!
  const _component_icono_estado_activo = _resolveComponent("icono-estado-activo")!
  const _component_icono_estado_inactivo = _resolveComponent("icono-estado-inactivo")!
  const _component_icono_retirado = _resolveComponent("icono-retirado")!
  const _component_icono_reparto = _resolveComponent("icono-reparto")!
  const _component_icono_entregado = _resolveComponent("icono-entregado")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode("div", _hoisted_10, [
                    _createVNode("h1", _hoisted_11, [
                      (_ctx.store_logo_url)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            src: _ctx.store_logo_url
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _createVNode("span", _hoisted_16, [
                        _hoisted_17,
                        (_ctx.shipping_number)
                          ? (_openBlock(), _createBlock("strong", _hoisted_18, _toDisplayString(_ctx.shipping_number), 1))
                          : _createCommentVNode("", true),
                        (!_ctx.shipping_number)
                          ? (_openBlock(), _createBlock("strong", _hoisted_19, " A confirmar"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode("p", _hoisted_22, _toDisplayString(_ctx.momentWrapper(_ctx.fecha_actualizacion).format('LLLL')), 1)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_23, [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "12"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_24,
                        _hoisted_25,
                        _createVNode("table", null, [
                          _createVNode("tbody", null, [
                            _createVNode("tr", null, [
                              _hoisted_26,
                              _createVNode("td", null, [
                                _createVNode("p", _hoisted_27, [
                                  (_ctx.tracking_carrier && _ctx.tracking_carrier != '')
                                    ? (_openBlock(), _createBlock("a", {
                                        key: 0,
                                        href: _ctx.tracking_carrier,
                                        target: "_blank"
                                      }, [
                                        (_ctx.carrier_name)
                                          ? (_openBlock(), _createBlock("strong", _hoisted_28, [
                                              _createTextVNode(_toDisplayString(' '+_ctx.carrier_name) + " ", 1),
                                              _hoisted_29
                                            ]))
                                          : _createCommentVNode("", true)
                                      ], 8, ["href"]))
                                    : _createCommentVNode("", true),
                                  (!_ctx.tracking_carrier && _ctx.tracking_carrier == '')
                                    ? (_openBlock(), _createBlock("strong", _hoisted_30, _toDisplayString(' '+_ctx.carrier_name), 1))
                                    : _createCommentVNode("", true),
                                  (!_ctx.carrier_name)
                                    ? (_openBlock(), _createBlock("strong", _hoisted_31, " A confirmar"))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createVNode("tr", null, [
                              _hoisted_32,
                              _createVNode("td", null, [
                                _createVNode("p", _hoisted_33, [
                                  _createVNode("strong", null, _toDisplayString(' '+_ctx.order_reference), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createVNode("div", _hoisted_34, [
            _createVNode("div", _hoisted_35, [
              _hoisted_36,
              _createVNode("div", _hoisted_37, [
                _createVNode("div", null, [
                  _createVNode(_component_icono_en_preparacion, {
                    color: !!_ctx.orderHistory.find(e => parseFloat(e.order_state.order) < 6) ? '#3598FE': '#BFBFBF'
                  }, null, 8, ["color"])
                ]),
                _createVNode("div", null, [
                  (!!_ctx.orderHistory.find(e => parseFloat(e.order_state.order) < 6))
                    ? (_openBlock(), _createBlock(_component_icono_estado_activo, {
                        key: 0,
                        style: {"margin":"15px 15px"}
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.orderHistory.find(e => parseFloat(e.order_state.order) < 6))
                    ? (_openBlock(), _createBlock(_component_icono_estado_inactivo, {
                        key: 1,
                        style: {"margin":"20px 15px"}
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", null, [
                  _createVNode("span", {
                    class: ['text-h6', 'black--text', !!_ctx.orderHistory.find(e => parseFloat(e.order_state.order) < 6) ? '' : '']
                  }, "En preparación", 2)
                ]),
                _createVNode("div", null, [
                  (!!_ctx.orderHistory.find(e => parseFloat(e.order_state.order) < 6))
                    ? (_openBlock(), _createBlock("span", _hoisted_38, _toDisplayString(_ctx.momentWrapper(_ctx.orderHistory.find(e => parseFloat(e.order_state.order) < 6).created_at).format('DD/MM/YYYY')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_39, [
                _createVNode("div", null, [
                  _createVNode(_component_icono_retirado, {
                    color: !!_ctx.orderHistory.find(e => e.order_state.name == 'Listo para Enviar') ? '#3598FE': '#BFBFBF'
                  }, null, 8, ["color"])
                ]),
                _createVNode("div", null, [
                  (!!_ctx.orderHistory.find(e => e.order_state.name == 'Listo para Enviar'))
                    ? (_openBlock(), _createBlock(_component_icono_estado_activo, {
                        key: 0,
                        style: {"margin":"15px 15px"}
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.orderHistory.find(e => e.order_state.name == 'Listo para Enviar'))
                    ? (_openBlock(), _createBlock(_component_icono_estado_inactivo, {
                        key: 1,
                        style: {"margin":"20px 15px"}
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", null, [
                  _createVNode("span", {
                    class: ['text-h6', 'black--text', !!_ctx.orderHistory.find(e => e.order_state.name == 'Listo para Enviar') ? '' : '']
                  }, "Listo para enviar", 2)
                ]),
                _createVNode("div", null, [
                  (!!_ctx.orderHistory.find(e => e.order_state.name == 'Listo para Enviar'))
                    ? (_openBlock(), _createBlock("span", _hoisted_40, _toDisplayString(_ctx.momentWrapper(_ctx.orderHistory.find(e => e.order_state.name == 'Listo para Enviar').created_at).format('DD/MM/YYYY')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_41, [
                _createVNode("div", null, [
                  _createVNode(_component_icono_reparto, {
                    color: !!_ctx.orderHistory.find(e => e.order_state.name == 'En Ruta') ? '#3598FE': '#BFBFBF'
                  }, null, 8, ["color"])
                ]),
                _createVNode("div", null, [
                  (!!_ctx.orderHistory.find(e => e.order_state.name == 'En Ruta'))
                    ? (_openBlock(), _createBlock(_component_icono_estado_activo, {
                        key: 0,
                        style: {"margin":"15px 15px"}
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.orderHistory.find(e => e.order_state.name == 'En Ruta'))
                    ? (_openBlock(), _createBlock(_component_icono_estado_inactivo, {
                        key: 1,
                        style: {"margin":"20px 15px"}
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", null, [
                  _createVNode("span", {
                    class: ['text-h6', 'black--text', !!_ctx.orderHistory.find(e => e.order_state.name == 'En Ruta') ? '' : '']
                  }, "En reparto", 2)
                ]),
                _createVNode("div", null, [
                  (!!_ctx.orderHistory.find(e => e.order_state.name == 'En Ruta'))
                    ? (_openBlock(), _createBlock("span", _hoisted_42, _toDisplayString(_ctx.momentWrapper(_ctx.orderHistory.find(e => e.order_state.name == 'En Ruta').created_at).format('DD/MM/YYYY')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_43, [
                _createVNode("div", null, [
                  _createVNode(_component_icono_entregado, {
                    color: !!_ctx.orderHistory.find(e => e.order_state.name == 'Entregado a Cliente') ? '#3598FE': '#BFBFBF'
                  }, null, 8, ["color"])
                ]),
                _createVNode("div", null, [
                  (!!_ctx.orderHistory.find(e => e.order_state.name == 'Entregado a Cliente'))
                    ? (_openBlock(), _createBlock(_component_icono_estado_activo, {
                        key: 0,
                        style: {"margin":"15px 15px"}
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.orderHistory.find(e => e.order_state.name == 'Entregado a Cliente'))
                    ? (_openBlock(), _createBlock(_component_icono_estado_inactivo, {
                        key: 1,
                        style: {"margin":"20px 15px"}
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", null, [
                  _createVNode("span", {
                    class: ['text-h6', 'black--text', !!_ctx.orderHistory.find(e => e.order_state.name == 'Entregado a Cliente') ? 'font-weight-bold' : '']
                  }, "Entregado", 2)
                ]),
                _createVNode("div", null, [
                  (!!_ctx.orderHistory.find(e => e.order_state.name == 'Entregado a Cliente'))
                    ? (_openBlock(), _createBlock("span", _hoisted_44, _toDisplayString(_ctx.momentWrapper(_ctx.orderHistory.find(e => e.order_state.name == 'Entregado a Cliente').created_at).format('DD/MM/YYYY')), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_45, [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "12"
                }, {
                  default: _withCtx(() => [
                    _hoisted_46,
                    _hoisted_47,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderHistory, (item, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: index,
                        style: {"display":"flex","justify-content":"space-between"}
                      }, [
                        _createVNode("span", _hoisted_48, _toDisplayString(item.order_state.name), 1),
                        _createVNode("span", _hoisted_49, [
                          _hoisted_50,
                          _createTextVNode(" " + _toDisplayString(_ctx.momentWrapper(item.created_at).format('DD/MM/YYYY HH:mm')), 1)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}